module.exports = __webpack_public_path__ + "img/icon-alert.f9cad9c.svg";